import React, { Fragment } from 'react';

const orderSummary = (props) => {
    const ingredientSummary = Object.keys(props.ingredints).map((ingr, i) => {
        return <li key={ingr + i}><span>{ingr.toUpperCase()}</span>: {props.ingredints[ingr].amount} </li>
    })
    return (
        <Fragment>
            <h3>Your Order</h3>
            <p> a burger with ingredients:</p>
            <ul>
                {ingredientSummary}
            </ul>
            <hr></hr>
            <p>Total: {props.totalPrice} AED</p>
        </Fragment>);
}

export default orderSummary;